import { ClipCommentsViewModel } from "./ViewModel";
import { ClipCommentForm } from "./ClipCommentForm";
import { CommentList } from "../Common/CommentList";

interface IClipCommentsProps {
  clipId: string;
  disabled?: boolean;
  scrollToBottom?: boolean;
  maxHeight?: string;
}

const ClipComments = ({
  clipId,
  disabled,
  scrollToBottom = false,
  maxHeight,
}: IClipCommentsProps) => {
  const { data, error, loading, loadMoreComments, hasNextPage, isLoadingMore } =
    ClipCommentsViewModel({ clipId });

  return (
    <CommentList
      connection={data?.clip?.comments ?? null}
      loading={loading}
      error={error}
      disabled={disabled}
      scrollToBottom={scrollToBottom}
      maxHeight={maxHeight}
      isLoadingMore={isLoadingMore}
      hasNextPage={hasNextPage}
      loadMoreComments={loadMoreComments}
      form={<ClipCommentForm clipId={clipId} />}
    />
  );
};

export { ClipComments };
